import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AppProviders } from './providers/AppProviders'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { setCfAccountHash, setR2PublicBase } from '@tenant/shared'
import './index.css'

// Surface preview-mode flag for shared/apiClient (avoids import.meta in shared/).
;(globalThis as { __TENANT_PREVIEW_MODE__?: boolean }).__TENANT_PREVIEW_MODE__ =
  import.meta.env?.VITE_PREVIEW_MODE === 'true'

// Initialize CF Images account hash for image URL resolution
setCfAccountHash(import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH || '')
// Rewrite raw r2.dev URLs → custom domain (Cloudflare R2 Custom Domain).
// Sprint G Phase 7: was hardcoded to https://media.agciceyim.az/ (tenant-A
// custom domain). Now sourced from VITE_R2_PUBLIC_BASE env so each tenant
// deploy can point at its own R2 custom domain. Empty string disables the
// rewrite — raw r2.dev URLs pass through unchanged.
setR2PublicBase(import.meta.env.VITE_R2_PUBLIC_BASE || '')

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <AppProviders>
      <App />
    </AppProviders>
  </ErrorBoundary>
)

